(function () {
  const selectors = {
    quantitySelector: "quantity-selector",
    productDetails: "[data-product-details]",
    productForm: "[data-product-form-regular]",
    price: "[data-product-pricing] [data-price]",
  };

  document.addEventListener("variant:change", (e) => {
    const { variant, form, section } = e.detail;
    const formData = new FormData(form[0]);
    const _section = section[0];
    const quantity = formData.get("quantity");
    const price = variant.price;

    console.log(variant);

    _section.querySelector("[data-price-value]").dataset.priceValue = price;

    const moneyFormat = JSON.parse(
      _section
        .closest(".shopify-section")
        .querySelector("[data-section-type='static-product']").innerHTML
    ).settings.money_format;

    const newPrice = Shopify.formatMoney(price * quantity, moneyFormat);

    _section
      .querySelectorAll(selectors.price)
      .forEach((itm) => (itm.innerHTML = newPrice));
  });

  document.addEventListener("quantity-updated", (e) => {
    const {
      el: { field },
      quantity,
    } = e.detail;

    field
      .closest(selectors.productDetails)
      .querySelector(selectors.productForm)
      .querySelector('input[name="quantity"]').value = quantity;

    const priceEl = field
      .closest(selectors.productDetails)
      .querySelector(selectors.price);

    const price = priceEl.dataset.priceValue;
    const moneyFormat = JSON.parse(
      field
        .closest(".shopify-section")
        .querySelector("[data-section-type='static-product']").innerHTML
    ).settings.money_format;

    const newPrice = Shopify.formatMoney(price * quantity, moneyFormat);

    field
      .closest(selectors.productDetails)
      .querySelectorAll(selectors.price)
      .forEach((itm) => (itm.innerHTML = newPrice));
  });
})();
